import type { ReactNode } from 'react';

/**
 * Leerzustand (Brief §7): ein Satz, eine Aktion, reduzierte
 * Linien-Illustration in Indigo-300 (Inline-SVG, keine Fremdgrafik).
 */
export function EmptyState({ text, action }: { text: string; action?: ReactNode }) {
  return (
    <div className="wb-empty">
      <svg
        className="wb-empty-illustration"
        width="72"
        height="48"
        viewBox="0 0 72 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        aria-hidden
      >
        <rect x="10" y="6" width="52" height="36" rx="6" />
        <path d="M18 16h24M18 24h36M18 32h16" />
        <circle cx="52" cy="15" r="2.6" />
      </svg>
      <div>{text}</div>
      {action && <div style={{ marginTop: 'var(--wb-space-md)' }}>{action}</div>}
    </div>
  );
}
